import React, { Component } from 'react';
import ProgressGraph from '../commoncomponents/progressGraph';

class FirstBox extends Component {
    constructor(props) {
        super(props);
        this.state = {};
    }
    componentDidMount(){
       
    }
    
    render() {
        const {value,name,progressValue1,progressResponse1,progressValue2,progressResponse2,progressValue3,progressResponse3} = this.props
        return (
            <div className="box outColor">
                             <div className="box-container">
                                 <div className="box-header">
                                     <h1>{value}</h1>
                                     <div className="box-icon">

                                       <i className="fa fa-pie-chart"></i>
                                    </div>

                                 </div>
                                 <div className="box-content">
                                     <div className="box-icon">

                                        <i className="fa fa-truck" style={{position:'relative',top:'-5px'}}></i>
                                     </div>
                                     <h2 style={{position:'relative',left:'5px'}}>{name}</h2>

                                 </div>
                                 <div className="box-bar-group">
                                 <ProgressGraph
                                value = {progressValue1}
                                response = {progressResponse1}
                                color="success"
                                />
                                <ProgressGraph
                                value = {progressValue2}
                                response = {progressResponse2}
                                color="dark"
                                />
                                <ProgressGraph
                                value = {progressValue3}
                                response = {progressResponse3}
                                color="primary" 
                                />

                                 </div>

                             </div>
                       
                         </div>
            
            
        );
    }
    
}

export default FirstBox;